var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "unauthorized" },
    [
      _c(
        "v-container",
        { attrs: { "fill-height": "" } },
        [
          _c(
            "v-row",
            { attrs: { align: "center", justify: "center" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "8", md: "6" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "pa-6", attrs: { elevation: "8" } },
                    [
                      _c(
                        "v-card-text",
                        { staticClass: "text-center" },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "mb-4",
                              attrs: { size: "80", color: "warning" }
                            },
                            [_vm._v(" mdi-shield-alert-outline ")]
                          ),
                          _c("h1", { staticClass: "display-1 mb-3" }, [
                            _vm._v(_vm._s(_vm.$t("auth.unauthorized.title")))
                          ]),
                          _c("p", { staticClass: "headline grey--text mb-4" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("auth.unauthorized.message")) +
                                " "
                            )
                          ]),
                          _c("div", { staticClass: "mb-4" }, [
                            _c("p", { staticClass: "body-1" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("auth.unauthorized.description")
                                  ) +
                                  " "
                              )
                            ])
                          ]),
                          _c("v-divider", { staticClass: "my-4" }),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex flex-column flex-sm-row justify-center align-center"
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ma-2",
                                  attrs: { color: "primary", large: "" },
                                  on: { click: _vm.goHome }
                                },
                                [
                                  _c("v-icon", { attrs: { left: "" } }, [
                                    _vm._v("mdi-home")
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("auth.unauthorized.goHome")
                                      ) +
                                      " "
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ma-2",
                                  attrs: {
                                    color: "secondary",
                                    large: "",
                                    outlined: "",
                                    loading: _vm.signingOut
                                  },
                                  on: { click: _vm.signOut }
                                },
                                [
                                  _c("v-icon", { attrs: { left: "" } }, [
                                    _vm._v("mdi-logout")
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("auth.unauthorized.signOut")
                                      ) +
                                      " "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c("div", { staticClass: "mt-4" }, [
                            _c("p", { staticClass: "caption grey--text" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("auth.unauthorized.contactAdmin")
                                  ) +
                                  " "
                              )
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }